import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getRoleBasedRoutes } from "../../api/navigation.api";
import { NavLinkItem } from "../../models/routes.model";

interface RoutesState {
  loading: boolean;
  error: string | null;
  nav: Record<string, NavLinkItem[]> | Record<string, NavLinkItem>;
}
const initialState: RoutesState = {
  nav: {},
  loading: false,
  error: null,
};

export const getRoutes = createAsyncThunk(
  "auth/getRoutes",
  async (_, { rejectWithValue }) => {
    try {
      const nav = await getRoleBasedRoutes();

      return nav;
    } catch (error: any) {
      return rejectWithValue("Login failed");
    }
  },
);

const routeSlice = createSlice({
  name: "routes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoutes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getRoutes.fulfilled, (state, action: PayloadAction<any>) => {
        state.nav = action.payload;
        state.loading = false;
      })

      .addCase(getRoutes.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default routeSlice.reducer;
